module.exports = __webpack_public_path__ + "static/media/socketio.bc989e9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/socketio.png
// module id = 121
// module chunks = 0